import React from "react";
import "./_SelectedRings.scss";

const renderRingText = (mainRing, holderRing) => {
  let ringText = "";
  if (mainRing && mainRing.fields) {
    ringText = mainRing.fields.title;
  }
  if (holderRing && holderRing.fields) {
    ringText = `${ringText}, 2 kpl ${holderRing.fields.title}`;
  }
  return <p className="ring-title">{ringText}</p>;
};

export const SelectedRings = ({ title = "", mainRing, holderRing }) => {
  return (
    <div className="selected-rings">
      <span className="component-title">{title}</span>
      {renderRingText(mainRing, holderRing)}
    </div>
  );
};
